import { useEffect, useState, type RefObject } from 'react';

const SCROLL_THRESHOLD = 8;

function findScrollParent(element: HTMLElement): HTMLElement | null {
  let scrollParent: HTMLElement | null = element.parentElement;

  while (scrollParent) {
    const { overflowY } = getComputedStyle(scrollParent);
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return scrollParent;
    }
    scrollParent = scrollParent.parentElement;
  }

  return null;
}

export function useScrollDetection(
  ref: RefObject<HTMLElement | null>
): boolean {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const scrollParent = findScrollParent(element);
    if (!scrollParent) return;

    const onScroll = () => {
      setIsScrolled(scrollParent.scrollTop > SCROLL_THRESHOLD);
    };

    scrollParent.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => scrollParent.removeEventListener('scroll', onScroll);
  }, [ref]);

  return isScrolled;
}
